import { EnvironmentId, NewTagId } from 'api/apiTypes';

const DATA_EXPORT_BASE_ENDPOINT = '/dataexport';

export const DataExportRoutes = {
  getDimensionsAndMetrics: (envGuid: EnvironmentId) => `${DATA_EXPORT_BASE_ENDPOINT}/dimensions-and-metrics/${envGuid}`,
  getDimensionsAndCountries: () => `${DATA_EXPORT_BASE_ENDPOINT}/dimensions-and-countries`,
  getTagVariablesAndBestPractices: (envGuid: EnvironmentId, tagId: NewTagId) =>
    `${DATA_EXPORT_BASE_ENDPOINT}/tag-variables-and-best-practices/${envGuid}/${tagId}`,
  createV2: () => `${DATA_EXPORT_BASE_ENDPOINT}/v2/create`,
  download: (jobId: string) => `${DATA_EXPORT_BASE_ENDPOINT}/download/${jobId}`,
  getHistory: (envGuid: EnvironmentId) => `${DATA_EXPORT_BASE_ENDPOINT}/history/${envGuid}`,
  // Scheduled export (JWT auth)
  createSchedule: () => `${DATA_EXPORT_BASE_ENDPOINT}/schedule`,
  listSchedules: (envGuid: EnvironmentId) => `${DATA_EXPORT_BASE_ENDPOINT}/schedules/${envGuid}`,
  getSchedule: (scheduleId: string) => `${DATA_EXPORT_BASE_ENDPOINT}/schedule/${scheduleId}`,
  updateSchedule: (scheduleId: string) => `${DATA_EXPORT_BASE_ENDPOINT}/schedule/${scheduleId}`,
  deleteSchedule: (scheduleId: string) => `${DATA_EXPORT_BASE_ENDPOINT}/schedule/${scheduleId}`,
  // Execute scheduled export (x-api-key auth)
  executeSchedule: () => `${DATA_EXPORT_BASE_ENDPOINT}/v2/execute`,
};
